export const MAX_ITEMS_TO_SELECT_ALL = 10000;
